module.exports = __webpack_public_path__ + "img/klaytn_alarm_pc.406aeadb.png";